module.exports = __webpack_public_path__ + "static/media/linkedin.d41d8cd9.svg";